<template>
  <div id="app" >
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/froala.css'
import './assets/custom.scss'
import { loadLanguageAsync } from './i18n'

const defaultlayout = 'default'

export default {
  name: 'app',
  computed: {
    layout () {
      return (this.$route.meta.layout || defaultlayout) + '-layout'
    }
  },
  mounted () {
    // attempt to determine the initial browser language
    // https://whyboobo.com/tutorials/detect-browser-language-javascript/
    var locale = (navigator.language || navigator.userLanguage).substr(0, 2)
    // this.$i18n.locale = locale
    loadLanguageAsync(locale)
  }
}
</script>

<style>

/* STOP THE BUTTON GLOW */
.btn-success:focus,
.btn-success:active{
    box-shadow:none !important;
    outline:0px !important;
}

.series-item {
  color: #ffffff;
  background-color: #138496;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: .25rem;
}

.activity-item {
    color: #333333;
    background-color: #B4CFCB;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
}

.activity-item i {
    color: #333333;
    background-color: #B4CFCB;
}

.bg-gradient {
  /* display: flex; */
  height: calc(100% - 65px);
  min-height: calc(100vh - 65px);
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+0,547ea0+100 */
  background: #ffffff; /* Old browsers */
  background: -moz-linear-gradient(top,  #ffffff 0%, rgba(84,126,160,.3) 100%); /* FF3.6-15 */
  background: -webkit-linear-gradient(top,  #ffffff 0%,rgba(84,126,160,.3) 100%); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom,  #ffffff 0%,rgba(84,126,160,.3) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#547ea0',GradientType=0 ); /* IE6-9 */
}
</style>

<style>
/**** NavBar Style
https://mycolor.space/?hex=%23547EA0&sub=1 */

#sidebar {
    width: 200px;
    top: 0;
    left: -200px;
    z-index: 999;
    background: whitesmoke;
    color: #000;
    transition: all 0.3s;
    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.2);
}

#sidebar .sidebar-header {
    padding: .5rem 1rem;
    background:rgba(84, 126, 160, .9);
    color: #ffffff;
    height: 56px;
    margin-bottom: 15px;
}

#sidebar ul.components {
    /* padding: 20px 0; */
    border-bottom: 1px solid #000000;
    margin-bottom: 10px;
}

#sidebar ul.components li:last-child {
    margin-bottom: 10px;
}

#sidebar ul p {
    color: #fff;
    padding: 10px;
}

#sidebar ul li a {
    padding: 6px 8px 6px 8px;  /* T R B L */
    font-size: 1em;
    display: block;
    color: #000000;
}
#sidebar ul li a:hover {
    /* color: #7386D5; */
    text-decoration: none;
    background: #fff;
}

#sidebar ul li.active > a, sidebar ul li.active > a[aria-expanded="true"] {
    color: #ffffff;
    background: #B06088;
}

ul ul a {
    font-size: 0.9em !important;
    padding-left: 30px !important;
    background: #fff;
}

#sidebar.active {
    /* margin-left: -250px; */
    left: 0;
}
 /* new */
#dismiss {
    /* width: 35px; */
    height: 35px;
    line-height: 15px;
    text-align: left;
    background: rgba(40, 167, 69, 0.4);
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    visibility: hidden;
}

#dismiss:hover {
    background: #fff;
    color: #7386D5;
}
</style>
